module.exports = __webpack_public_path__ + "Icon_Working Days.c250ca02dda8f57dc2cb.png";